import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendConfirmationForPromissory } from 'services/auth'

interface ISendAuthenticationPayload {
    phone_number: string
    code: string
}

const UseSendAuthentication = (
    setIsSubmit: React.Dispatch<React.SetStateAction<boolean>>
) => {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: ISendAuthenticationPayload) => {
            return sendConfirmationForPromissory(payload)
        },
        // Both branches used to land on `/promissory/pay-for-promissory/`, a
        // screen that was never finished and has never been opened once in the
        // app's whole history: its «مبلغ» lines were empty, the bank logos were
        // commented out, and its pay button posted `destination: "no"` with a
        // hard-coded total of 0. It shipped a wallet switch that could not spend
        // the wallet either, which is why it was removed.
        //
        // The `two_factor_token` went nowhere even then — that screen read
        // neither it nor the phone number. So the auth genuinely is the whole
        // step; say so and go back, instead of opening a receipt full of blanks.
        onSuccess: () => {
            toast.success('احراز هویت انجام شد')
            navigate('/promissory')
        },
        onError: () => {
            toast.error('کد وارد شده صحیح نمی باشد')
            setIsSubmit(false)
        },
    })

    return { isLoading, mutate }
}

export default UseSendAuthentication
